// extracted by mini-css-extract-plugin
export default {"slideItem":"index_slideItem_5eYT5 clearfix","sonItem":"index_sonItem_A1MdH","slides":"index_slides_dtjwb"};